import styled, { css } from 'styled-components'

import { Toolbar } from '@components/ui'

import { generateMaxHeightBreakPoint, generateMaxWidthBreakPoint, generateMinWidthBreakPoint } from '@constants'

import { NavLink } from '../elements'

export const StyledToolbar = styled(Toolbar)<{ open: boolean }>`
  align-items: flex-start;
  max-height: ${({ theme }) => theme.appBarHeight}px;
  flex-direction: column;

  ${generateMaxWidthBreakPoint('small')} {
    padding: 0;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.common.inputBackground};

    ${({ open, theme }) =>
      open &&
      css`
        max-height: 550px;
        padding-bottom: 10px;
        border-bottom: 1px solid ${theme.colors.gray[105]};
      `}
  }

  ${generateMaxHeightBreakPoint('medium')} {
    max-height: ${({ theme }) => theme.appBarHeightMedium}px;
  }

  ${generateMinWidthBreakPoint('small')} {
    padding-right: 0;
  }
`

export const LinkSpan = styled.span`
  display: inline-block;
  height: ${({ theme }) => theme.appBarHeight}px;
  line-height: 20px;
  padding: ${({ theme }) => (theme.appBarHeight - 20) / 2}px 8px;
  font-size: 16px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
  ${generateMaxHeightBreakPoint('medium')} {
    height: ${({ theme }) => theme.appBarHeightMedium}px;
    padding: ${({ theme }) => (theme.appBarHeightMedium - 20) / 2}px 8px;
  }
  ${generateMinWidthBreakPoint('large')} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`

export const StyledNavLink = styled(NavLink)`
  color: ${({ theme }) => theme.colors.common.offBlack};
  display: inline-flex;
  align-items: center;
  text-decoration: none;

  &.active > ${LinkSpan} {
    background-color: ${({ theme }) => theme.colors.common.oceanBlue};
    color: ${({ theme }) => theme.colors.gray[0]};
  }
`
